// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kSXwn","mainPoster":"Header_mainPoster__dig+k","bottomShadow":"Header_bottomShadow__Enccd"};